import GroupsOverviewNuttall from '../../../../../customized/alan-nuttall-flexeserve-eu/components/DeviceManager/Overview/GroupsOverview';
import { ToggleComponent } from '../../../../../featureToggle';
import GroupsOverview from './GroupsOverview';

export default ToggleComponent(GroupsOverview, {
  styledComponentsVariants: {
    'alan-nuttall-flexeserve-eu': GroupsOverviewNuttall,
  },
});
